export default "__VITE_PUBLIC_ASSET__186133e5__"